import { lazy } from "react";
import type { AppRouteObject } from "../../routes";

const LastLoginListingPage = lazy(() => import("../LastLoginListingPage"));

export const LastLoginListingRoute: AppRouteObject = {
  path: "/:realm/last-login-listing",
  element: <LastLoginListingPage />,
  breadcrumb: (t) => t("titleUsers"),
  handle: {
    access: "query-users",
  },
};
